module.exports = __webpack_public_path__ + "static/media/registered.7587c6b5.svg";